import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import scriptLoader from 'react-async-script-loader'

import RaisedButton from 'material-ui/RaisedButton';
import DatePicker from 'material-ui/DatePicker';
import AutoComplete from 'material-ui/AutoComplete';
import TextField from 'material-ui/TextField';
import LinearProgress from 'material-ui/LinearProgress';

import moment from 'moment';

import InfiniteScroll from 'react-infinite-scroller';
import RefreshIndicator from 'material-ui/RefreshIndicator';

// import Giphy from '../../components/Giphy';
import Item from './Item';

import './Load.css';


// const giphyStyle = {
//     width: '180px'
// };

const loaderStyle = {
  position: 'relative',
  top: '90%',
  left: '50%',
  transform: `translate(-50%, -50%)`
};


const dateStyle = {
    width: 'auto',

};

const dateTextStyle = {
    border: 'none',
    fontSize: '1em',
    color: '#000000',
    height: '90px',
    width: 'auto',
    maxWidth: '480px',
    fontFamily: 'AvenirNextLTBold'
};


const descriptionStyle = {
    float: 'left',
    width: '526px'
};


const hoursStyle = {
    float: 'left',
    width: '83px'
};

const taskStyle = {
    float: 'left',
    width: '420px'
};

const addButtonStyle = {
    float: 'left',
    minWidth: '30px',
    marginTop: '30px',
    marginLeft: '20px',
    boxShadow: 'none'
};

// const giphys = [
//     {
//         label: 'Si, que divertido',
//         gifKey: '28JycIOcizTrV5iiAy'
//     },
//     {
//         label: 'Tarea, cliente, horas. Tarea, cliente, horas. Horas, horas, cliente. Tarea, tarea, tarea',
//         gifKey: 'csg19wsPaUZrZIjWwy'
//     }
// ]

// const selectedIx = Math.floor(Math.random()*giphys.length);





class Load extends Component {

    state = {
        minDate: null,
        maxDate: null,
        tasks: [],
        loadingComputes: false,
        computes: [],
        hasMoreComputes: true,
        currentPage: 0,
        computedToday: false,
        loadingAdd: false,
        date: null,
        task: null,
        hours: '',
        description: ''
    };

    componentDidMount() {

        axios
        .get('user/tasks')
        .then(res => {

            res.data.tasks.map((object) => {
                 // object.fullname = '&lt;strong&gt;' + object.project.client.name.toUpperCase() + '&lt;/strong&gt;' + ',  ' + object.project.name + '  (' + object.name + ')';
                 object.fullname = object.project.client.name + '.  ' + object.project.name + '  (' + object.name + ')';
            });

            this.setState({ tasks: res.data.tasks })

        })
        .catch(err => console.log(err))

        const minDate = new Date();
        const maxDate = new Date();
        minDate.setFullYear(minDate.getFullYear() - 1);
        minDate.setHours(0, 0, 0, 0);
        this.setState({minDate: minDate});
        this.setState({maxDate: maxDate});

    }

    dateHandleChange = (event, res) => {
        var finaldate = res;
        this.setState({date: finaldate});
    }

    descriptionHandleChange = (event, value) => {
        this.setState({description: value});
    }

    hoursHandleChange = (event, value) => {
        value = value.replace(',','.'); // si se cargaron decimales con coma, los reemplazo por punto
        value = value.indexOf('.') == 0 ? '0' + value : value; // si la persona mete . al principio, le agrego el 0
        // value = value.replace(/[^0-9.]/g,'');

        if(/^\d*\.?\d{0,2}$/.test(value)==false){ // dejo un punto, dos decimales y nada que no sea numero
          value = value.substring(0,value.length - 1);
        }

        if(value>24){ // no deberias poder crgar mas de 24 horas para un mismo día
            value = 24
        }

        this.setState({hours: value});
    }




    taskHandleChange = (chosenRequest, index) => {
        this.setState({task: chosenRequest.id});
        this.refs.hourField.focus();
    }

    handleItemDelete = (target) => {

        axios
        .post('user/computes/delete',{
             id: target.props.id
         })
        .then(res => {
             console.log(res)

             this.setState({
                 computes: this.state.computes.filter((_, i) => _.id !== target.props.id)
             });

         })
        .catch(err => console.log(err));

    };

    loadComputes(page) {
        var that = this;

        setTimeout(function() { // timeout para que no intente cargar misma pagina varias veces en el no-bounce infinite scroll

            if(that.state.loadingComputes){
                return false;
            }
            that.setState({loadingComputes: true});

            var newpage = that.state.currentPage + 1;
            that.setState({currentPage: newpage});

            axios
            .post('user/computes',{
                page: that.state.currentPage
            })
            .then(res => {

                that.setState({ computes: that.state.computes.concat(res.data.computes.data) })

                // si hay computos hoy, escondo funny
                res.data.computes.data.map((object) => {
                     var inputDate = moment(object.date, 'YYYY-MM-DD').toDate();
                     if(moment().isSame(inputDate, 'day')) {
                         that.setState({computedToday: true});
                     }
                });


                if(res.data.computes.to === null){
                    console.log('STOP');
                    that.setState({hasMoreComputes: false});
                }

                that.setState({loadingComputes: false});

            })
            .catch(err => console.log(err))

        }, 500);


    }


    descriptionHandleKey = (ev) => {
        if (ev.key === 'Enter') {
            this.refs.taskField.focus();
            ev.preventDefault();
        }
    }


    submitAdd = (ev) => {
        if (ev.key === 'Enter') {
            this.addHandle();
            ev.preventDefault();
        }
    }


    addHandle = () => {
        // var that = this;

        this.setState({loadingAdd : true});

        axios
        .post('user/computes/new',{
            description: this.state.description,
            date: this.state.date,
            hours: this.state.hours,
            task: this.state.task
        })
        .then(res => {
            console.log(res)

            this.setState({ computes: [res.data.compute, ...this.state.computes] })

            this.setState({
                            loadingAdd : false,
                            description : '',
                            hours : ''
                        });

            this.refs.descriptionField.focus();

            // desactivar giphy al cargar
            if(this.state.date!==null){
                var inputDate = moment(this.state.date, 'YYYY-MM-DD').toDate();
                if(moment().isSame(inputDate, 'day')) {
                    this.setState({computedToday: true});
                }
            }
            else{
                this.setState({computedToday: true});
            }


        })
        .catch(err => console.log(err))

    }


    render() {

        const { loadingComputes, loadingAdd, date, hours, task, description } = this.state;

        var computes = [];
        this.state.computes.map((object, i) => {

            let newDay = (i===0 || object.date !== this.state.computes[i-1].date) ? true : false;

            computes.push(
                <Item key={object.id} id={object.id} item={object} newDay={newDay} onClick={this.handleItemClick} onDelete={this.handleItemDelete} />
            );

        });

        const dataSourceConfig = {
          text: 'fullname',
          value: 'id'
        };

        let dateClassName = this.state.date ? "date-field" : "date-field empty";
        let dateLabel = this.state.date ? "Cómo te fue el" : "Cómo te fue";

        let goodToGo = hours.length>0&&description.length>0&&task!=null?true:false;

        return (
            <div className="load">

                <div className="welcome">
                    <div className="wrapper">

                        <h1><span>{dateLabel}&nbsp;</span>
                           <DatePicker
                               hintText="hoy"
                               minDate={this.state.minDate}
                               maxDate={this.state.maxDate}
                               onChange={this.dateHandleChange}
                               value={date}
                               defaultDate={this.state.maxDate}
                               autoOk={true}
                               className={dateClassName}
                               style={dateStyle}
                               textFieldStyle={dateTextStyle}
                               formatDate={(date) => moment(date).format('dddd D')}
                           />
                           <span className="suffix">&#9660;</span>
                        </h1>

                    </div>
                </div>

                <div className="add-frame">
                    <div className="wrapper">

                        <TextField
                            hintText=""
                            floatingLabelText="Estuve haciendo..."
                            onChange={this.descriptionHandleChange}
                            className="description-field"
                            style={descriptionStyle}
                            onKeyPress={this.descriptionHandleKey}
                            value={description}
                            ref="descriptionField"
                            autoFocus
                        />

                        <AutoComplete
                            floatingLabelText="Para quién?"
                            filter={AutoComplete.fuzzyFilter}
                            dataSource={this.state.tasks}
                            maxSearchResults={8}
                            dataSourceConfig={dataSourceConfig}
                            openOnFocus={false}
                            onNewRequest={this.taskHandleChange}
                            value={task}
                            className="task-field"
                            style={taskStyle}
                            menuStyle={{width: 420}}
                            listStyle={{width: 420}}
                            ref="taskField"
                        />

                        <TextField
                            hintText=""
                            floatingLabelText="Horas?"
                            onChange={this.hoursHandleChange}
                            className="hour-field"
                            style={hoursStyle}
                            value={hours}
                            onKeyPress={goodToGo ? this.submitAdd : undefined}
                            ref="hourField"
                        />

                        <RaisedButton
                            label="+"
                            primary={true}
                            onClick={this.addHandle}
                            className="add-field"
                            style={addButtonStyle}
                            disabled={!goodToGo}
                        />

                    </div>
                </div>

                {/*( !loadingComputes && !this.state.computedToday )&&
                <div className="funny">
                    <div className="wrapper">

                        <Giphy tag='horas' gifkey={giphys[selectedIx].gifKey} style={giphyStyle} label={giphys[selectedIx].label}/>

                    </div>
                </div>
                */}

                <div className="computes">

                    <div className="wrapper">

                        <InfiniteScroll
                          pageStart={0}
                          loadMore={this.loadComputes.bind(this)}
                          hasMore={this.state.hasMoreComputes}
                          loader={null}>

                            <div className="list">

                                {loadingAdd &&
                                <div className="item ghost">
                                    <LinearProgress mode="indeterminate" />
                                </div>}

                                {computes}
                            </div>

                        </InfiniteScroll>

                    </div>

                    {loadingComputes &&
                      <div className="loading">
                          <RefreshIndicator
                               size={40}
                               left={10}
                               top={0}
                               status="loading"
                               className="loader"
                               style={loaderStyle}
                          />
                      </div>}

                </div>

            </div>
        );

    }




}


const mapStateToProps = (state, ownProps) => ({
  auth: state.auth_reducer
});

const AppContainer = connect(
  mapStateToProps
)(Load);


export default scriptLoader(
  [
    'https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.21.0/moment.min.js'
  ]
)(AppContainer)


// WEBPACK FOOTER //
// ./src/modules/user/Load.js